import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icons as I } from '../pack-icons';

const links = [
  { to: '/app', label: 'navDashboard', Icon: I.home, end: true },
  { to: '/app/calendar', label: 'navCalendar', Icon: I.calendar },
  { to: '/app/create', label: 'newPost', Icon: I.plus, create: true },
  { to: '/app/library', label: 'navLibrary', Icon: I.library },
];

export default function MobileNavigation({ open, onOpen, menuButtonRef }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const moreActive = ['/app/plan', '/app/research', '/app/brandkit', '/app/settings', '/app/referrals', '/app/help']
    .some(path => pathname === path || pathname.startsWith(`${path}/`));
  return <nav className="mobile-navigation" aria-label={t('topbar.openMenu')} inert={open ? '' : undefined}>
    {links.map(({ to, label, Icon, end, create }) => <NavLink key={to} to={to} end={end}
      className={({ isActive }) => `mobile-navigation__item${create ? ' mobile-navigation__create' : ''}${isActive ? ' is-active' : ''}`}>
      <span className="mobile-navigation__icon" aria-hidden="true"><Icon size={21} /></span>
      <span>{t(`sidebar.${label}`)}</span>
    </NavLink>)}
    <button ref={menuButtonRef} type="button" className={`mobile-navigation__item${moreActive ? ' is-active' : ''}`} onClick={onOpen}
      aria-expanded={open} aria-controls="app-navigation" aria-haspopup="dialog" title={t('topbar.openMenu')}>
      <svg width="21" height="21" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="5" cy="12" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="19" cy="12" r="2" />
      </svg>
      <span>{t('sidebar.navMore')}</span>
    </button>
  </nav>;
}
